import axiosHttpClient from '@/helpers/axiosHttpClient.js'
import fixDate from '@/helpers/date/fixDate.js'
import { defaultExpiresTime, newsRetryTime, nowTime } from '@/stores/storeDefaults.js'
import { defineStore } from 'pinia'
import { useStorage } from '@vueuse/core'
import { computed, ref } from 'vue'

export const useNewsStore = defineStore('news', () => {
	const news = useStorage('news', [])
	const loading = ref(false)
	const expires = useStorage('news-expires', null)

	const list = computed(() => {
		fetchNews()
		return news.value.slice(0, 4)
	})

	/**
	 * Fetch all the news.
	 * @param {boolean} [force] - Whether to force fetching the news
	 * @returns {Promise} - A promise to act upon
	 */
	async function fetchNews(force = false) {
		if (force) { loading.value = false }
		if (loading.value) { return }
		if (new Date().getTime() < expires.value && !force) { return }

		loading.value = true
		axiosHttpClient
			.get('news/nfo')
			.then(response => {
				const newsData = response?.data ?? []
				news.value = newsData.map(newsItem => {
					newsItem.date = fixDate(newsItem?.date)
					return newsItem
				})
				expires.value = `${nowTime() + defaultExpiresTime}`
			})
			.catch(() => {
				expires.value = `${nowTime() + newsRetryTime}`
			})
			.finally(() => { loading.value = false })
	}

	return {
		news,
		loading,
		expires,
		list,
		fetch: fetchNews
	}
})
